import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-construcao',
  templateUrl: './construcao.component.html',
  styleUrls: ['./construcao.component.scss']
})
export class ConstrucaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
